import map from "lodash/map";
import pickBy from "lodash/pickBy";
import size from "lodash/size";
import { NODE_DEFAULT_SIZE } from "../../constants";
import createWebGL2NodeStyle from "./createWebGL2NodeStyle";
import iconIdBase64 from "./iconIdBase64";
import initializeIconIdBase64 from "./initializeIconIdBase64";
import SIZES from "./styleSizes";
export default async (webGL2NodeStyles) => {
    await initializeIconIdBase64(iconIdBase64);
    const unloadedIconIdBase64 = pickBy(iconIdBase64, (base64src, iconId) => { var _a; return Boolean(base64src && !((_a = webGL2NodeStyles.iconIdMap[iconId]) === null || _a === void 0 ? void 0 : _a._default)); });
    if (!size(unloadedIconIdBase64))
        return;
    await Promise.all(map(unloadedIconIdBase64, async (base64src, iconId) => {
        const style = await createWebGL2NodeStyle(base64src, NODE_DEFAULT_SIZE.width, NODE_DEFAULT_SIZE.height, SIZES.IMG_PADDING, "ellipse");
        if (style) {
            webGL2NodeStyles.iconIdMap[iconId] = {
                _default: style
            };
        }
    }));
};
